import React from 'react';
import { Global, css } from '@emotion/core';

import colors from './colors';

const globalCss = css`
  @import url('https://use.typekit.net/feh5nbt.css');

  html {
    box-sizing: border-box;
  }
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  * {
    font-family: 'sofia-pro';

    ::-webkit-scrollbar {
      height: 6px;
      width: 6px;
      background-color: rgba(255, 255, 255, 0);
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-thumb {
      border: 2px solid rgba(255, 255, 255, 0);
      border-radius: 2px;
      background-clip: padding-box;
    }

    ::-webkit-scrollbar-track {
      background-color: rgba(255, 255, 255, 0);
    }

    ::-webkit-scrollbar-thumb {
      transition: background-color 0.2s linear;
      background-color: ${colors.ultraLightGrey};
    }
  }
  ul {
    padding: 0;
    margin-right: 0;
  }
`;

export default function GlobalStyles() {
  return <Global styles={globalCss} />;
}
